"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Popper2 = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _InputAdornment2 = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Search2 = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Avatar2 = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _Person2 = _interopRequireDefault(require("@material-ui/icons/Person"));

var _ListItem2 = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ExpandMore2 = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ExpandLess2 = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _ListItemText2 = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

ViewMore.propTypes = {
  onSelect: _propTypes["default"].func,
  moreViews: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    type: _propTypes["default"].string,
    name: _propTypes["default"].string
  }))
};

function ViewMore(_ref) {
  var moreViews = _ref.moreViews,
      onSelect = _ref.onSelect;
  var classes = useStyles();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleToggle = function handleToggle(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose(event, reason) {
    if (reason === "toggleInput") {
      return;
    }

    if (anchorEl) {
      anchorEl.focus();
    }

    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  var id = open ? "search-view" : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_ListItem2["default"], {
    selected: open,
    button: true,
    onClick: handleToggle,
    style: {
      marginLeft: 5,
      borderRadius: 4,
      alignItems: "center",
      width: "auto",
      padding: "0 7px",
      height: 32
    },
    "aria-describedby": id
  }, /*#__PURE__*/React.createElement(_ListItemText2["default"], null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 600,
      fontSize: 13
    }
  }, "More")), open ? /*#__PURE__*/React.createElement(_ExpandLess2["default"], {
    fontSize: "small"
  }) : /*#__PURE__*/React.createElement(_ExpandMore2["default"], {
    fontSize: "small"
  })), /*#__PURE__*/React.createElement(_Popper2["default"], {
    id: id,
    open: open,
    anchorEl: anchorEl,
    placement: "bottom-start",
    className: classes.popper
  }, /*#__PURE__*/React.createElement(_Autocomplete2["default"], {
    open: true,
    onClose: handleClose,
    multiple: true,
    classes: {
      paper: classes.paper,
      option: classes.option,
      popperDisablePortal: classes.popperDisablePortal
    },
    autoHighlight: true,
    onChange: function onChange(event, newValue) {
      handleClose();
      onSelect(newValue[0].id);
    },
    disableCloseOnSelect: true,
    disablePortal: true,
    renderTags: function renderTags() {
      return null;
    },
    noOptionsText: "No labels",
    renderOption: function renderOption(option) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          alignItems: "center",
          display: "flex"
        }
      }, /*#__PURE__*/React.createElement(_Avatar2["default"], {
        className: classes.avatarSm,
        style: {
          background: "red"
        },
        variant: "rounded"
      }, /*#__PURE__*/React.createElement(_Person2["default"], {
        fontSize: "small"
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.text
      }, option.name));
    },
    options: moreViews,
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(_TextField2["default"], {
        style: {
          padding: 10,
          width: "100%"
        },
        size: "small",
        variant: "outlined",
        type: "text",
        autoFocus: true,
        autoComplete: "off",
        placeholder: "Search view",
        ref: params.InputProps.ref,
        inputProps: params.inputProps,
        InputProps: {
          classes: {
            root: classes.rootInputProps,
            notchedOutline: classes.notchedOutlineInputProps
          },
          endAdornment: /*#__PURE__*/React.createElement(_InputAdornment2["default"], {
            position: "end"
          }, /*#__PURE__*/React.createElement(_Search2["default"], {
            style: {
              fontSize: 15
            }
          }))
        }
      });
    }
  })));
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    rootInputProps: {
      height: 32,
      border: "1px solid #E8E9EC",
      backgroundColor: "white",
      fontSize: 13,
      padding: "5px 5px"
    },
    notchedOutlineInputProps: {
      border: "none"
    },
    avatar: {
      background: "red",
      height: 46,
      width: 46
    },
    avatarSm: {
      borderRadius: 6,
      background: "red",
      height: 24,
      width: 24,
      marginRight: 8
    },
    nested: {
      paddingLeft: theme.spacing(4),
      borderRadius: 4
    },
    icon: {
      height: 28,
      width: 28,
      fontSize: 18,
      borderRadius: 50,
      transition: "all 0.1s ease",
      "&:hover": {
        transform: "scale(1.3)"
      }
    },
    popper: {
      marginTop: 10,
      border: "1px solid rgba(27,31,35,.15)",
      borderRadius: 8,
      boxShadow: "0 4px 17px 6px rgb(0 0 0 / 10%)",
      zIndex: 1,
      fontSize: 13,
      color: "#586069",
      backgroundColor: "#FFFFFF"
    },
    paper: {
      boxShadow: "none",
      margin: 0,
      color: "#586069",
      fontSize: 13,
      borderRadius: 8
    },
    option: {
      minHeight: "auto",
      alignItems: "flex-start",
      padding: 8,
      '&[aria-selected="true"]': {
        backgroundColor: "transparent"
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.action.hover
      }
    },
    popperDisablePortal: {
      position: "relative"
    },
    text: {
      flexGrow: 1
    },
    close: {
      opacity: 0.6,
      width: 18,
      height: 18
    }
  };
});
var _default = ViewMore;
exports["default"] = _default;